var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "main-content main_center",
      style: _vm.mainContentViewHeight,
    },
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 2 } }, [
            _c(
              "div",
              { staticStyle: { "padding-right": "10px" } },
              [
                _c(
                  "el-menu",
                  {
                    ref: "leftmenu",
                    staticClass: "leftMenu",
                    attrs: { "default-active": "GC" },
                    on: { select: _vm.selectGroup },
                  },
                  _vm._l(_vm.groupList, function (item, index) {
                    return _c(
                      "el-menu-item",
                      { key: item.id, attrs: { index: item.value } },
                      [_vm._v(_vm._s(item.name))]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-col",
            { staticStyle: { "padding-left": "10px" }, attrs: { span: 22 } },
            [
              _c("div", { staticClass: "search-content" }, [
                _c(
                  "div",
                  { staticClass: "mainBtn", staticStyle: { padding: "0" } },
                  [
                    _vm.hasBtnPermission("btn_jz_table_metas_add")
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.addOrUpdateHandle()
                              },
                            },
                          },
                          [_vm._v("添加")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "searchBtn", staticStyle: { padding: "0" } },
                  [
                    _c("span", { staticClass: "label-form" }, [
                      _vm._v("关键字："),
                    ]),
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { clearable: "", placeholder: "请输入内容搜索" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.searchBtn.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.dataForm.searchKey,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataForm, "searchKey", $$v)
                        },
                        expression: "dataForm.searchKey",
                      },
                    }),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "12px" },
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.searchBtn },
                      },
                      [_vm._v("搜索")]
                    ),
                    _c("el-divider", { attrs: { direction: "vertical" } }),
                    _c("el-button", {
                      attrs: { type: "text", icon: "el-icon-refresh" },
                      on: { click: _vm.refresh },
                    }),
                  ],
                  1
                ),
              ]),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.dataListLoading,
                      expression: "dataListLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    "header-cell-style": this.$globalGrayTableHeaderStyle,
                    data: _vm.dataList,
                    "row-key": "id",
                    height: _vm.tableMaxHeight,
                    border: "",
                    stripe: "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      fixed: "",
                      type: "index",
                      align: "center",
                      label: "序号",
                      width: "60",
                      index: _vm.getRowsIndex,
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      fixed: "right",
                      "header-align": "center",
                      align: "center",
                      width: "100",
                      label: "操作",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.hasBtnPermission("btn_jz_table_metas_add")
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.configDataset(
                                          scope.row.id,
                                          scope.row.displayName
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("配置 ")]
                                )
                              : _vm._e(),
                            _vm.hasBtnPermission("btn_jz_table_metas_out")
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.exportMeta(
                                          scope.row.id,
                                          scope.row.displayName
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("导出 ")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "displayName",
                      "header-align": "left",
                      width: "200",
                      "show-overflow-tooltip": true,
                      align: "left",
                      label: "名称",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "datasetCode",
                      "header-align": "left",
                      align: "left",
                      width: "100",
                      label: "数据集代码",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "parentDatasetCode",
                      "header-align": "left",
                      align: "left",
                      width: "100",
                      label: "父级代码",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "tableName",
                      "header-align": "left",
                      align: "left",
                      "show-overflow-tooltip": true,
                      width: "180",
                      label: "表名",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "unionColumn",
                      "header-align": "center",
                      align: "center",
                      "show-overflow-tooltip": true,
                      label: "查重字段",
                    },
                  }),
                  false
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "status",
                          "header-align": "center",
                          align: "center",
                          label: "状态",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.status === 0
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            size: "small",
                                            type: "danger",
                                          },
                                        },
                                        [_vm._v("正常")]
                                      )
                                    : _c(
                                        "el-tag",
                                        { attrs: { size: "small" } },
                                        [_vm._v("正常")]
                                      ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          98648976
                        ),
                      })
                    : _vm._e(),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      "header-align": "center",
                      align: "center",
                      width: "180",
                      label: "创建时间",
                    },
                  }),
                ],
                1
              ),
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.pageIndex,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.pageSize,
                  total: _vm.totalCount,
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "size-change": _vm.sizeChangeHandle,
                  "current-change": _vm.currentChangeHandle,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.addOrUpdateVisible
        ? _c("add-or-update", {
            ref: "addOrUpdate",
            on: { refreshDataList: _vm.getDataList },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }